import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";

function Portfolio({ eyebrow, id, intro, title, videos }) {
  const visibleVideos = videos.filter((item) => item.render !== false && item.private !== true);

  return (
    <section className="section portfolioSection" id={id}>
      {eyebrow || title || intro ? (
        <div className="sectionHeading">
          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          {title ? <h2>{title}</h2> : null}
          {intro ? <p>{intro}</p> : null}
        </div>
      ) : null}

      <div className="portfolioGrid">
        {visibleVideos.map(({ name, video }) => (
          <Video key={name} video={video} name={name} />
        ))}
      </div>
    </section>
  );

  function Video({ name, video }) {
    const id = getYouTubeId(video);

    return (
      <article className="videoCard">
        <div className="videoCard__frame">
          <LiteYouTubeEmbed id={id} title={name} />
        </div>
        <span>{name}</span>
      </article>
    );
  }
}

function getYouTubeId(video) {
  if (!video) {
    return "";
  }

  if (!video.includes("http")) {
    return video;
  }

  if (video.includes("youtu.be/")) {
    return video.split("youtu.be/")[1].split("?")[0];
  }

  if (video.includes("watch?v=")) {
    return video.split("watch?v=")[1].split("&")[0];
  }

  return video;
}

export default Portfolio;
